import { GlobalNotification, Link } from '@lacedltd/laced-components'
import * as React from 'react'
import { useTranslation } from 'hooks/useTranslation'

const GlobalNotificationBanner: React.FC<GlobalNotificationBannerProps> = ({
  showGlobalReadMore
}) => {
  const { t } = useTranslation()

  return (
    <GlobalNotification>
      <div>
        {t('react_components.top_nav.current_events_message')}{' '}
        {showGlobalReadMore ? (
          <Link
            href={t('react_components.top_nav.more_info_path')}
            size="m"
            underline
            darkMode
          >
            {t('react_components.top_nav.more_info_text')}
          </Link>
        ) : null}
      </div>
    </GlobalNotification>
  )
}

export default GlobalNotificationBanner

interface GlobalNotificationBannerProps {
  showGlobalReadMore?: boolean
}
